import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/button";
import { use } from "react";

export default function UnAuthorized() {
  const location = useLocation();
  const auth = useAuth();
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-8rem)] bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-600">403 - Unauthorized</h1>
        <p className="mt-4 text-lg text-gray-700">
          You do not have permission to access this page.
        </p>
        <div className="flex items-center justify-center mt-6">
        {!auth.user ? (
          <Link to={"/auth/login" + location.search}>
            <Button className="ml-2 px-5 py-2 text-sm font-semibold bg-purple-600 hover:bg-purple-700 text-white rounded shadow">
              Login
            </Button>
          </Link>
        ) : null}
        </div>
      </div>
    </div>
  );
}
